export default "__VITE_ASSET__Drg99ngQ__"